import { render, staticRenderFns } from "./EmailSenderContent.vue?vue&type=template&id=7807f77e"
import script from "./EmailSenderContent.vue?vue&type=script&lang=js"
export * from "./EmailSenderContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports